import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { loadStatusCodeMsg } from 'enEXchange';

export default store => ({
  path: Routes.ticket.child.cancelLation.key,
  onEnter(nextState, replace, callback) {
    const { channel } = nextState.location.query;

    loadStatusCodeMsg(['checkOrderTicket', 'checkTicketFlight']);
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-取消行程列表页',
      channel_id: channel ? channel : '',
    });
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const cancelLation = require('./components/cancelLation').default;
        cb(null, cancelLation);
      },
      'cancelLation'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/cancelLation/index.js